import React from 'react';
import { Link } from 'react-router';

const TABS = [
    { key: 'occupation', label: 'Ocupación', icon: 'fas fa-percent', path: 'occupation' },
    { key: 'forecast',   label: 'Forecast',  icon: 'fas fa-chart-line', path: 'forecast' },
    { key: 'guests',     label: 'Huéspedes', icon: 'fas fa-id-card',    path: 'guests' },
    { key: 'close',      label: 'Cierre',    icon: 'fas fa-cash-register', path: 'close' },
    { key: 'transactions', label: 'Transacciones', icon: 'fas fa-exchange-alt', path: 'transactions' },
    { key: 'charges', label: 'Cargos', icon: 'fas fa-file-invoice-dollar', path: 'charges' },
];

const ReportTabs = ({ active, id }) => (
    <div className="d-flex justify-content-center mt-3" style={{ gap: 4 }}>
        {TABS.map(tab => {
            const isActive = tab.key === active;
            return (
                <Link
                    key={tab.key}
                    to={`/reports/${tab.path}/${id}`}
                    className="d-flex flex-column align-items-center px-3 py-2"
                    style={{
                        minWidth: 90,
                        borderRadius: 6,
                        textDecoration: 'none',
                        background: isActive ? 'rgba(0,198,254,0.10)' : 'rgba(255,255,255,0.04)',
                        borderBottom: isActive ? '2px solid #00C6FE' : '2px solid transparent',
                        transition: 'all .15s',
                    }}
                >
                    <i className={`${tab.icon} font-16 ${isActive ? 'blue' : 'whiteish'}`} />
                    <span
                        className={`font-10 poppins mt-1 ${isActive ? 'white' : 'whiteish'}`}
                        style={{ lineHeight: 1.3, textAlign: 'center' }}
                    >
                        {tab.label}
                    </span>
                </Link>
            );
        })}
    </div>
);

export default ReportTabs;
